import { debounce } from 'lodash';
import moment from 'moment';
import * as Yup from 'yup';

import { api_validate_signup_email_path } from '@routes';
import request from '@utils/backend-api/request';
import { FULL_NAME_REGEX } from '@utils/constants';

interface ValidateEmailParams {
  email: string;
}

const DEBOUNCE_MS = 500;

const validateEmail = async (params: ValidateEmailParams): Promise<boolean> => {
  const response = await request('get', api_validate_signup_email_path(params));
  return response.success;
};

const debounceValidateEmail = debounce(validateEmail, DEBOUNCE_MS);

const validationSchema = (isYPPlan: boolean) =>
  Yup.object()
    .shape({
      email: Yup.string()
        .required('Email address is required')
        .email('Please enter a valid email')
        .test('validate', 'This email address already has an account', async function (email) {
          if (this.parent.userEmail && email) {
            // Skip validation if the initial state of email is not null
            return true;
          }

          const isValid = await debounceValidateEmail({ email });
          // if isValid is undefined, it means there's no request sent yet so it's valid
          return isValid === undefined || isValid;
        }),
      name: Yup.string()
        .matches(FULL_NAME_REGEX, 'Please enter a first and last name')
        .required('Full name is required'),
    })
    .test('dob-required', null, (schema) => {
      const { dob } = schema;
      if (!isYPPlan || dob) return true;
      return new Yup.ValidationError('Birthday is required', null, 'dob');
    })
    .test('is-dob-valid', null, (schema) => {
      const age = moment().diff(new Date(schema.dob), 'years');
      if (!isYPPlan || (age <= 30 && age >= 13)) return true;

      return new Yup.ValidationError('Must be 30 or under', null, 'dob');
    });

export default validationSchema;
